




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'ObchodniPripadListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'CRM_ObchPripady',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
